import DarkModeSwitch from './dark-mode-switch';
export default DarkModeSwitch;